export const STATIC_WEBSITE = process.env.REACT_APP_STATIC_WEBSITE
export const isRealProd = process.env.REACT_APP_IS_REAL_PROD === 'true'
export const authAppURL = process.env.REACT_APP_AUTH_APP_URL
export const authorizedSSOOrigins = [authAppURL]
export const waitingTimeForSSOResponses = 3000
export const zeroBounceAPIKey = process.env.REACT_APP_ZEROBOUNCE_API_KEY
export const defaultCountry = 'FR'
